import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, DollarSign, TrendingUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Hero = () => {
  const { t } = useTranslation();
  
  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            {t('hero.title')}
          </h1>
          <p className="hero-subtitle">
            {t('hero.subtitle')}
          </p>
          <div className="hero-cta-group">
            <Link to="/services" className="btn-primary btn-large">
              {t('hero.ctaPrimary')}
              <ArrowRight size={20} />
            </Link>
            <a href="https://wa.me/5588996527079" target="_blank" rel="noopener noreferrer" className="btn-secondary btn-large">
              {t('hero.ctaSecondary')}
            </a>
          </div>
        </div>
        <div className="hero-visual" data-testid="hero-dashboard">
          <div className="hero-dashboard">
            {/* Scorecards */}
            <div className="hero-scorecard">
              <div className="hero-sc-icon"><DollarSign size={16} /></div>
              <div className="hero-sc-info">
                <span className="hero-sc-label">Faturamento</span>
                <span className="hero-sc-value">R$ 84.2k</span>
              </div>
              <span className="hero-sc-badge hero-sc-up">+12%</span>
            </div>
            <div className="hero-scorecard">
              <div className="hero-sc-icon hero-sc-icon-blue"><TrendingUp size={16} /></div>
              <div className="hero-sc-info">
                <span className="hero-sc-label">ROI</span>
                <span className="hero-sc-value">4.3x</span>
              </div>
              <span className="hero-sc-badge hero-sc-up">+8%</span>
            </div>
            {/* Donut Chart */}
            <div className="hero-widget hero-donut-widget">
              <span className="hero-widget-label">Canais</span>
              <div className="hero-donut-container">
                <svg viewBox="0 0 36 36" className="hero-donut-svg">
                  <circle cx="18" cy="18" r="14" fill="none" stroke="var(--color-border)" strokeWidth="4" />
                  <circle cx="18" cy="18" r="14" fill="none" stroke="var(--color-primary)" strokeWidth="4" strokeDasharray="42 88" strokeDashoffset="25" strokeLinecap="round" />
                  <circle cx="18" cy="18" r="14" fill="none" stroke="var(--color-secondary)" strokeWidth="4" strokeDasharray="28 88" strokeDashoffset="67" strokeLinecap="round" />
                </svg>
                <span className="hero-donut-center">3</span>
              </div>
            </div>
            {/* Line Chart */}
            <div className="hero-widget hero-line-widget">
              <span className="hero-widget-label">Tendência</span>
              <svg viewBox="0 0 120 40" className="hero-line-svg" preserveAspectRatio="none">
                <polyline
                  points="0,35 15,28 30,30 45,18 60,22 75,12 90,15 105,5 120,8"
                  fill="none"
                  stroke="var(--color-primary)"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <polyline
                  points="0,35 15,28 30,30 45,18 60,22 75,12 90,15 105,5 120,8"
                  fill="url(#heroLineGrad)"
                  stroke="none"
                />
                <defs>
                  <linearGradient id="heroLineGrad" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="var(--color-primary)" stopOpacity="0.25" />
                    <stop offset="100%" stopColor="var(--color-primary)" stopOpacity="0" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
